import React, { useState } from "react";
import { IoIosExpand } from "react-icons/io";
import { useLocation } from "react-router";
import ProjectDetailInfo from "../components/projects/projectdetail/ProjectDetailInfo";
import ProjectInfo from "../components/projects/projectdetail/ProjectInfo";
import RelatedCollaborators from "../components/projects/projectdetail/RelatedCollaborators";
import "swiper/css";
import "swiper/css/pagination";
import CloseIcon from '@mui/icons-material/Close';

const ProjectDetailPage = () => {
  const location = useLocation();
  const { projectDetails } = location.state;
  const [selectedImage, setSelectedImage] = useState(null);

  const openImagePopup = (img) => {
    setSelectedImage(img);
  };

  const closeImagePopup = () => {
    setSelectedImage(null);
  };

  const allImages = Array.from(
    new Set([
      projectDetails.Image1,
      ...(projectDetails.ImageUrls || []),
    ])
  ).filter(Boolean);

  return (
    <>
      <div className="lg:px-40">
        <ProjectInfo projectDetails={projectDetails} />
        {allImages.length > 0 && (
          <div className="mt-5 grid grid-cols-4 gap-4">
            {allImages.map((img, index) => (
              <div className="relative" key={index} onClick={() => openImagePopup(img)}>
                <img
                  src={img}
                  alt={`Project view ${index + 1}`}
                  className="w-full h-40 sm:h-60 object-cover cursor-pointer"
                />
                <div className="absolute inset-0 flex flex-col gap-4 items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300 bg-black bg-opacity-50 text-white cursor-pointer">
                  <div className="hover:border-transparent hover:rounded-lg hover:p-6 hover:mx-4 hover:my-4">
                    <IoIosExpand className="text-6xl" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <ProjectDetailInfo projectDetails={projectDetails} onImageClick={openImagePopup} />
        <RelatedCollaborators projectDetails={projectDetails} />
      </div>

      {selectedImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80"
          onClick={closeImagePopup}
        >
          <div
            className="relative max-w-5xl w-full max-h-[90vh] mx-4"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage}
              alt="Expanded project view"
              className="w-full max-h-[85vh] object-contain rounded-lg"
            />
            <button
              className="absolute top-4 right-4 bg-white/90 backdrop-blur text-gray-800 rounded-full w-10 h-10 flex items-center justify-center shadow-lg hover:bg-red-500 hover:text-white transition-all duration-200 z-10"
              onClick={closeImagePopup}
              aria-label="Close image"
            >
              <CloseIcon fontSize="small" />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ProjectDetailPage;
